import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAdmin } from './AdminAuth';

const AdminLogin = () => {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch (err) {
      setError('Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b1510] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="brand text-3xl text-white">flix<span className="text-[#3ddc9a]">.</span></span>
          <p className="text-white/50 text-sm mt-2">Admin dashboard</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="w-12 h-12 rounded-2xl bg-[#0e9f6e]/12 flex items-center justify-center mb-6">
            <Lock size={22} className="text-[#0e9f6e]" />
          </div>
          <h1 className="font-display text-2xl font-700 text-[#0f1712]">Welcome back</h1>
          <p className="text-[#0f1712]/55 text-sm mt-1 mb-6">Sign in to manage FLIX.</p>

          <label className="block text-xs font-semibold text-[#0f1712]/60 mb-1.5">Username</label>
          <input value={username} onChange={(e) => setUsername(e.target.value)} required
            className="w-full rounded-xl border border-[#0f1712]/15 px-4 py-3 text-sm outline-none focus:border-[#0e9f6e] focus:ring-2 focus:ring-[#0e9f6e]/30 transition mb-4" />

          <label className="block text-xs font-semibold text-[#0f1712]/60 mb-1.5">Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full rounded-xl border border-[#0f1712]/15 px-4 py-3 text-sm outline-none focus:border-[#0e9f6e] focus:ring-2 focus:ring-[#0e9f6e]/30 transition" />

          {error && <p className="text-sm text-red-500 mt-3">{error}</p>}

          <button type="submit" disabled={loading}
            className="w-full mt-6 bg-[#0e9f6e] text-white rounded-xl px-5 py-3.5 text-sm font-semibold hover:bg-[#0c8a60] transition-colors disabled:opacity-60">
            {loading ? 'Signing in\u2026' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
